import React from "react";
import { Tabs, Tab } from "react-bootstrap";
// import ListResugarcane from "./ListResugarcane";
import ListResugarcaneContract from "./ListResugarcaneContract";
import CheckDeed from "../CheckDeed/CheckDeed";
import ListContractOCSB from "../Contract/ContractListForOcsb";
import DopaList from "../Dopa/DopaList";

function CheckStatusTab() {
  return (
    <>
      <Tabs
        defaultActiveKey="sent"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        {/* <Tab eventKey="passaway" title="ตรวจสอบการเสียชีวิต"> */}
        {/* <ListResugarcane /> */}
        {/* </Tab> */}
        <Tab eventKey="sent" title="ตรวจสอบการส่งอ้อย">
          <ListResugarcaneContract />
        </Tab>
        <Tab eventKey="dopa" title="ข้อมูลทะเบียนราษฎร์">
          <DopaList />
        </Tab>
        <Tab eventKey="contract" title="ข้อมูลคู่สัญญา">
          <ListContractOCSB />
        </Tab>
        <Tab eventKey="deed" title="ตรวจสอบที่ดิน">
          <CheckDeed />
        </Tab>
      </Tabs>
    </>
  );
}

export default CheckStatusTab;
